'use client';
import clsx from 'clsx';
import React from 'react';
import { factory } from '../../../factory/factory.utils.mjs';
import { Box } from '../../../Other/Box/Box.mjs';
import { useRadioGroupContext } from '../RadioGroup.context.mjs';
import { RadioButtonCardProvider } from './RadioButtonCard.context.mjs';
import classes from './RadioButtonCard.module.css.mjs';

const RadioButtonCard = factory((props, ref) => {
  const { className, style, value, checked, onClick, onKeyDown, ...rest } = props;
  const ctx = useRadioGroupContext();
  const _checked = typeof checked === "boolean" ? checked : ctx?.value.includes(value || "") || false;
  const handleKeyDown = (event) => {
    onKeyDown?.(event);
    if (["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].includes(event.nativeEvent.code)) {
      event.preventDefault();
      const siblings = Array.from(document.querySelectorAll(`[role="radio"]`));
      const currentIndex = siblings.findIndex((element) => element === event.target);
      const nextIndex = currentIndex + 1 >= siblings.length ? 0 : currentIndex + 1;
      const prevIndex = currentIndex - 1 < 0 ? siblings.length - 1 : currentIndex - 1;
      if (event.nativeEvent.code === "ArrowDown") {
        siblings[nextIndex].focus();
        siblings[nextIndex].click();
      }
      if (event.nativeEvent.code === "ArrowUp") {
        siblings[prevIndex].focus();
        siblings[prevIndex].click();
      }
      if (event.nativeEvent.code === "ArrowLeft") {
        siblings[prevIndex ].focus();
        siblings[prevIndex ].click();
      }
      if (event.nativeEvent.code === "ArrowRight") {
        siblings[nextIndex ].focus();
        siblings[nextIndex ].click();
      }
    }
  };
  return /* @__PURE__ */ React.createElement(RadioButtonCardProvider, { value: { checked: _checked } }, /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      ref,
      role: "radio",
      type: "button",
      "aria-checked": _checked,
      onClick: (event) => {
        onClick?.(event);
        ctx?.onChange(value || "");
      },
      ...rest,
      className: clsx(className, "kohler-radio-button-card-root", classes.radioButtonCard, className),
      style,
      onKeyDown: handleKeyDown
    }
  ));
});

export { RadioButtonCard };
